














































































import { Component, Prop, Vue } from 'vue-property-decorator';
import LoginRequiredPanel from '@/components/LoginRequiredPanel.vue';
import { HistoricListing } from '@/models/HistoricListing';

@Component({
    components: {
        LoginRequiredPanel,
    },
})
export default class SalesHistoryPanel extends Vue {

    @Prop(String) public readonly detailType: string | undefined;
    public widthThresholdValue: number = 768;
    public historicListingItem: HistoricListing | null  = null;

    get isMobile(): boolean {
        return this.$q.screen.width <= this.widthThresholdValue;
    }

    get historicListings(): HistoricListing[] | undefined {
        let historicListingsArray;
        if (this.detailType === 'listing') {
            historicListingsArray = this.$store.state.listings.selectedListingDetail.HistoricListings;
        } else if (this.detailType === 'parcel') {
            if (this.$store.state.parcels.selectedParcelDetail.Listings && this.$store.state.parcels.selectedParcelDetail.Listings.length) {
                historicListingsArray = this.$store.state.parcels.selectedParcelDetail.Listings[0].HistoricListings;
            }
            if ((this.$store.state.parcels.selectedParcelDetail.PvsHistoricListings && this.$store.state.parcels.selectedParcelDetail.PvsHistoricListings.length)) {
                historicListingsArray = this.$store.state.parcels.selectedParcelDetail.PvsHistoricListings;
            }
        }

        if (!historicListingsArray) {
            return undefined;
        }

        // active listings need a DOM fix because it is shown as 0
        if (this.detailType === 'listing' && historicListingsArray[0].DOM === 0) {
            historicListingsArray[0].DOM = this.$store.state.listings.selectedListingDetail.DaysOnMarket;
        }

        return historicListingsArray;
    }

    get isLoggedIn() {
        return this.$store.state.isLoggedIn;
    }

    get config() {
        return this.$store.state.config;
    }

    public doShowHistoryListingButton(mlsNum: string): boolean {

        const isSelectedListing: boolean = (this.$store.state.listings.selectedListingDetail != null && this.$store.state.listings.selectedListingDetail.MlsNo === mlsNum);

        const isNonMls: boolean = mlsNum === 'n/a';

        const doShowButton: boolean = (!isSelectedListing && !isNonMls);
        return doShowButton;
    }

    public onOpenHistoricListing(mlsNum: string) {
        window.open('https://www.remaxnova.com/historic/' + mlsNum, '_blank');
    }

    public formattedPrice(listPrice: number|string): string {
        if (listPrice === null || listPrice === undefined) {
            return 'Unknown';
        }

        try {
            if (typeof listPrice === 'string') {
                listPrice = parseInt(listPrice, 10);
            }

            if (listPrice.toString().indexOf('$') !== -1) {
                return listPrice.toString();
            }

            let lPrice = listPrice.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            lPrice = '$' + lPrice.substr(0, lPrice.length - 3);

            return lPrice;
        } catch {
            return 'Unknown';
        }
    }

    public getStatusAsString(status: string, fieldName: number) {
        if (fieldName === 1) {
            return this.formattedPrice(status);
        } else {
            if (status === null || status === undefined) {
                return 'UNKNOWN';
            }
            if (status === '1' || status === '1_0') {
                return 'FOR SALE';
            } else if (status === '2' || status === '2_0') {
                return 'SOLD';
            } else if (status === '3' || status === '3_0') {
                return 'PENDING';
            } else if (status === '4' || status === '4_0') {
                return 'EXPIRED';
            } else if (status === '5' || status === '5_0') {
                return 'CANCELLED';
            } else if (status === '5_1') {
                return 'WITHDRAWN';
            } else if (status === '6' || status === '6_0') {
                return 'RENTED';
            } else {
                return 'UNKNOWN';
            }
        }
    }

    public historyStatusClass(status: number): string {
        if (status === null || status === undefined) {
            return 'listingStatusType_NOSTATUS';
        }

        if (status === 1) {
            return 'tblHistFORSALE';
        } else if (status === 2) {
            return 'tblHistSOLD';
        } else if (status === 3) {
            return 'tblHistPENDING';
        } else if (status === 4) {
            return 'tblHistEXPIRED';
        } else if (status === 5) {
            return 'tblHistCANCELLED';
        } else if (status === 5) {
            return 'tblHistPENDING';
        } else if (status === 6) {
            return 'tblHistPENDING';
        } else {
            return 'tblHistNOSTATUS';
        }
    }

    public generateStatusLabel(item: HistoricListing): string {
        let label = item.ListStatusLabel;

        if (label === 'n/a') {
            label = 'Change / Transfer';
        } else if (label === 'SOLD') {
            label = 'SOLD - ' + this.formattedPrice(item.ListPriceLast);
        }

        return label;
    }
}

